module.exports = __webpack_public_path__ + "img/dialog1-box-diamond.04a9662b.png";